import { ComponentRendering, Placeholder, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import breakpoints from '../../constants/breakpoints.constants';
import ctaTypes from '../../enums/CTA.enums';
import useMediaQuery from '../../hooks/useMediaQuery';
import { findCtaType } from '../../utils/popUpCtaType.utils';
import { targetLinkdsk } from '../../utils/targetDskLink';
import CTA from '../@shared/CTA';
import CTAWithArrowEditable from '../@shared/CTAWithArrow/ctaWithArrow';
import { CustomText } from '../@shared/customText';
import DownloadCTA from '../@shared/downloadCTA';
import Picture from '../@shared/picture';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import './index.scss';
import { TextModuleModel } from './models/textModule.model';
import { TextModuleProps } from './types/textModule.types';

const TextModule = (props: TextModuleProps): JSX.Element => {
  const isEE = props.sitecoreContext?.pageEditing;
  const model = new TextModuleModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  const popUpCtaType = findCtaType(props.rendering);
  const secondaryCTAClassName =
    popUpCtaType === 'primary-cta' ? 'text-module__buttons--primary-popup' : 'text-module__buttons--secondary-popup';

  const primaryCtaMap = {
    ['primary-orange']: ctaTypes.primaryOrange, // eslint-disable-line
    ['primary-white']: ctaTypes.primaryWhite, // eslint-disable-line
    ['primary-black']: ctaTypes.primaryBlack, // eslint-disable-line
  };

  const secondaryCtaMap = {
    ['secondary-white']: ctaTypes.secondaryWhite,
    ['secondary-black']: ctaTypes.secondaryBlack,
  };

  const popUpClassName = isEE ? 'generic-popupEE-width' : '';
  const { imageWidth } = model.getLoadedImageDimension(isDesktop);

  return (
    <>
      {model.dataSource ? (
        <>
          <div
            className={`text-module text-module--${model.textPosition?.value?.toLowerCase()} text-module--${model.backgroundColor?.value?.toLowerCase()} text-module--text-color-${model.textColor?.toLowerCase()}`}
          >
            <div className={`text-module__content text-module__content--${model.textPosition?.value}`}>
              <div style={{ maxWidth: `min(${imageWidth}px, 100%)`, marginLeft: 'auto', marginRight: 'auto' }}>
                <Picture
                  editorialImageProps={{
                    desktopImage: model.image,
                    mobileImage: model.mobileImage,
                    desktopTransformation: 'Size1000',
                    mobileTransformation: 'Size1000',
                    cssClassPictureEl: 'text-module__image-wrapper',
                    alt: `${model.image?.value?.alt}`,
                  }}
                />
              </div>
              {model.eyebrow && <Text tag="p" field={model.eyebrow} className={'text-module__eyebrow'} />}
              <CustomText tag={model.headingTag} field={model.title} className={'text-module__title'} />
              {model.subtitle && <RichText tag="div" field={model.subtitle} className={'text-module__subtitle rich-text'} />}
              {model.bodyText && <RichText tag="div" field={model.bodyText} className={'text-module__text rich-text color-inherit-link'} />}
              <div className={`text-module__buttons ${secondaryCTAClassName}`}>
                <div className="text-module__popup--wrapper">
                  {(isEE || (model.link1?.value?.text && model.link1?.value?.href)) && (
                    <CTA
                      type={primaryCtaMap[`${model.primaryCtaColor}`]}
                      field={model.link1}
                      target={targetLinkdsk(model?.link1, isDesktop)}
                      extraClassName={`text-module__primary-link text-module__primary-link--${model.primaryCtaColor}`}
                    />
                  )}
                  {model.validLink2Exists && model.link2 && (
                    <div className={`text-module__secondary-link text-module__secondary-link--${model.secondaryCtaColor}`}>
                      <CTAWithArrowEditable field={model.link2} target={targetLinkdsk(model?.link2, isDesktop)} />
                    </div>
                  )}
                  {!model.validLink2Exists && model.downloadButtonLink && (
                    <DownloadCTA
                      field={model.downloadButtonLink}
                      type={secondaryCtaMap[`${model.secondaryCtaColor}`]}
                      extraClassName={`text-module__secondary-link text-module__secondary-link--${model.secondaryCtaColor}`}
                    />
                  )}
                  <div className={`text-module__popup-link ${popUpClassName}`}>
                    <Placeholder name={'jss-generic-popup'} rendering={props.rendering as ComponentRendering} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default withSitecoreContext()(TextModule);
